import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card-container" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Work Orders ")
const _hoisted_5 = { class: "flex search" }
const _hoisted_6 = { class: "p-input-icon-left field-container" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_8 = { class: "container flex-grow-1 workorders" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Loading workorders "),
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-spin pi-spinner" })
], -1)
const _hoisted_10 = {
  key: 1,
  class: "container flex-grow-1"
}

import { useAuth0 } from "@auth0/auth0-vue";
import { ref } from "@vue/reactivity";
import { onMounted, onBeforeMount, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from "../store";
import { MutationTypes } from "../store/mutations";
import { WOItem } from '../store/state';
import { FilterMatchMode } from 'primevue/api';
import { useToast } from 'primevue/usetoast';
import ErrorModal from './ErrorModal.vue';
import { openErrorModal } from '@/composables/useErrorLog';


export default /*#__PURE__*/_defineComponent({
  name: 'WorkOrders',
  setup(__props) {

const store = useStore();
const toast = useToast();
const auth0 = useAuth0();
const items = ref([]);
const filters = ref({
  'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
});
const storeid = ref('');
const role = ref('');
const storestatus = ref('');
const loading = ref(false);
const empty = ref(false);
const router = useRouter();
const itemlist = computed(() => items.value.map((b) => {
  b.FullName = b.FirstName + " " + b.LastName;
  return b;
}));

onBeforeMount(async () => {
    storeid.value = store.state.storeid;
    role.value = store.state.role;
    storestatus.value = store.state.storestatus;
    if (storestatus.value == 'Disable')
    router.push('/storedisable');
});

onMounted(async () => {
    const woitems: WOItem[] = store.state.woitems;
    if (woitems.length > 0) {
        items.value = woitems;
    } else {
        loadWordOrders();
    }
});

async function loadWordOrders() {
    loading.value = true;
    const storeid = store.state.storeid;
    const WOurl = `${process.env.VUE_APP_NODEJS_BASE_URL}workorders/${storeid}`;
    const accessToken = await auth0.getAccessTokenSilently();
    try {
        const response = await fetch(WOurl, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            }
        });
        loading.value = false;
        const data = await response.json();
        if (response.status > 400) {
            throw new Error(JSON.stringify(data.error));
        }
        const datamessage = data.message;
        store.commit(MutationTypes.SET_WOITEMS, datamessage);
        items.value = datamessage;
        if ((items.value.length) < 1) {
            empty.value = true;
        } else {
            empty.value = false;
        }
    } catch (e) {
        empty.value = true;
        openErrorModal(e.message);
    }
}

function clearFilter() {
    initFilters();
}

function initFilters() {
    filters.value = {
        'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
}

const onRowSelect = (event) => {
    toast.add({ severity: 'info', summary: 'WO Selected', detail: 'Name: ' + event.data.WorkOrderNumber, life: 3000 });
    router.push({ name: 'updateorder', params: { workordernumber: event.data.WorkOrderNumber } });
};


return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ErrorModal),
    _createVNode(_component_Toast),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_Button, {
            type: "button",
            icon: "pi pi-refresh",
            class: "p-button-text p-button-rounded",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (loadWordOrders()))
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_InputText, {
            modelValue: filters.value['global'].value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value['global'].value) = $event)),
            placeholder: "Search"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_Button, {
            type: "button",
            icon: "pi pi-times",
            class: "p-button-text p-button-rounded clear",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (clearFilter()))
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (!empty.value)
        ? (_openBlock(), _createBlock(_component_DataTable, {
            key: 0,
            value: _unref(itemlist),
            paginator: true,
            rows: 10,
            stripedRows: "",
            paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
            rowsPerPageOptions: [10, 20, 50],
            breakpoint: "640px",
            currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}",
            filters: filters.value,
            selectionMode: "single",
            onRowSelect: onRowSelect,
            loading: loading.value,
            dataKey: "WorkOrderNumber"
          }, {
            loading: _withCtx(() => [
              _hoisted_9
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "WorkOrderNumber",
                header: "WO #",
                sortable: true
              }),
              _createVNode(_component_Column, {
                field: "FullName",
                header: "Full Name",
                sortable: true
              }),
              _createVNode(_component_Column, {
                field: "Plate",
                header: "Plate #",
                sortable: true
              }),
              _createVNode(_component_Column, {
                field: "Make",
                header: "Make",
                sortable: true
              }),
              _createVNode(_component_Column, {
                field: "Model",
                header: "Model",
                sortable: true
              }),
              _createVNode(_component_Column, {
                field: "Color",
                header: "Color",
                sortable: true
              }),
              _createVNode(_component_Column, {
                field: "VIN",
                header: "VIN",
                sortable: true
              })
            ]),
            _: 1
          }, 8, ["value", "filters", "loading"]))
        : _createCommentVNode("", true),
      (empty.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, "No work orders found."))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})